import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CONFIG_TOKEN } from '@core/tokens';

@Component({
  selector: 'app-footer',
  imports: [TranslatePipe, NgTemplateOutlet],
  templateUrl: './footer.component.html',
  host: {
    class: 'flex flex-col border-t border-stroke-tertiary p-6 text-xs text-foreground-primary-80 lg:p-10',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public readonly APP_VERSION = inject(CONFIG_TOKEN).appVersionTag;
}
